export default __webpack_public_path__ + "1e91dc776e9df9b0f74e0614d9dc493a.png";